import { BulkPrintHistoryRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class BulkPrintHistroryService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new BulkPrintHistoryRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	print(bphItemId, sourceOfChange){
		var url = this.routeService.print(bphItemId, sourceOfChange);
		return this.apiClient.get(url);
	}
}

export default BulkPrintHistroryService;
